import React, { useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  Modal,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
  Divider,
  darken,
  Tabs,
  Tab,
  IconButton,
  TextField,
  InputAdornment,
  Pagination,
  Stack,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  TableBody,
  Checkbox,
  FormControl,
  DialogContentText,
  CircularProgress,
} from "@mui/material";
import {
  Close as CloseIcon,
  Delete,
  Label,
} from "@mui/icons-material";
import { lighten } from "@material-ui/core";
import CopiedTooltip from "../components/common/CopiedTooltip";
import { openModal, closeModal } from "../features/slices/modalSlice";
import FlipNumbers from "react-flip-numbers";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import ArrowDropUp from '@mui/icons-material/ArrowDropUp';
import ArrowDropDown from '@mui/icons-material/ArrowDropDown';


import { selectCurrentToken } from "../features/slices/authSlice";

import Image from "../components/common/Image";
import Announcement from "../components/common/Announcement";
import ImageCarousel from "../components/common/ImageCarousel";
import CardCarousel from "../components/common/CardCarousel";
import TextCarousel from "../components/common/TextCarousel";
import Backdrop from "../components/common/Backdrop";
import AccordionComponent from "../components/common/Accordion";
import Sidebar from '../components/common/SideBar';
import { Link } from 'react-router-dom';
import SlotIcon from "../icons/header/SlotIcon";

import {
  useGetGameCategoryQuery,
  useLazyGetGameProviderGameItemQuery,
  useGetGameProviderQuery,
  useLazyGetLaunchGameQuery,
  useLazyGetGameItemQuery
} from "../features/api/gameApiSlice";
import { useGetHomePageQuery } from "../features/api/homeApiSlice";
import { useGetProfileQuery, useGetShareLinkQuery } from "../features/api/userApiSlice";

import CasinoIcon from "../icons/header/CasinoIcon";
import SportIcon from "../icons/header/SportIcon";
import FishingIcon from "../icons/header/FishingIcon";
import PromotionIcon from "../icons/header/PromotionIcon";
import VipIcon from "../icons/header/VipIcon";
import WalletCard from "../components/common/WalletCard";
import SabungIcon from "../icons/header/SabungIcon";
import LiveCasinoCarousel from "../components/common/LiveCasinoCarousel";
import DOMPurify from "dompurify";
import GameCard from "../components/Game/GameCard";
import * as Constant from "../features/constant";
import { ALT_TAG_ICON_REFERRAL } from "../features/constant";
import moment from 'moment';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import Swal from "sweetalert2";

const PATH = process.env.PUBLIC_URL;

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const Home = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [popupOpen, setPopupOpen] = useState(false);
  const [affiliatePopupOpen, setAffiliatePopupOpen] = useState(false);
  const mobileView = useMediaQuery(theme.breakpoints.down("sm"));
  const tabletView = useMediaQuery(theme.breakpoints.down("md"));
  const [selectedGameCategory, setSelectedGameCategory] = useState("");

  const isLoggedIn = useSelector(selectCurrentToken);
  const [number, setNumber] = useState(14020000);
  const [gameShownValue, setGameShownValue] = useState(0);
  const lang = localStorage.getItem("language");
  const [selectedRowIndex, setSelectedRowIndex] = useState(0);

  const [scrollPosition, setScrollPosition] = useState(0);
  const visibleItems = 4;
  const { gameCategoryCode, gameProviderCode } = useState("");
  const [currentProviderId, setCurrentProviderId] = useState(null);
  const [offset, setOffset] = useState(1);
  let pathname = window.location.pathname?.toLowerCase();
  const [domContentLoaded, setDOMContentLoaded] = useState(false);
  const domain = window.location.origin

  const [hasGameList, setHasGameList] = useState(false);
  const [appProviderName, setAppProviderName] = useState("");
  const [mobileUsername, setMobileUsername] = useState("");
  const [mobilePassword, setMobilePassword] = useState("");
  const [selectedProvider, setSelectedProvider] = useState();
  const [showLoading, setShowLoading] = useState(false);

  const [rows, setRows] = useState([
    { number2To6: '', big: '', small: '', a3d: '', abc3d: '', a1: '', a2: '', a3: '', a4: '', a5: '', rv: false, box: false, iBox: false },
    { number2To6: '', big: '', small: '', a3d: '', abc3d: '', a1: '', a2: '', a3: '', a4: '', a5: '', rv: false, box: false, iBox: false },
    { number2To6: '', big: '', small: '', a3d: '', abc3d: '', a1: '', a2: '', a3: '', a4: '', a5: '', rv: false, box: false, iBox: false },
  ]);
  const [platformType, setPlatformType] = useState("");

  let customMenuItems = [{ name: 'Hot Game', code: 'HOT_GAME', image: process.env.REACT_APP_HEADER_LOGO + '/HOT_GAME.png' }].concat(Constant.getCustomMenuItems());

  const [additionalGameBarItems, setAdditionalGameBarItems] = useState(customMenuItems);

  const {
    data: gameCategory,
    isFetching: isGameCategoryFetching,
    isLoading: isGameCategoryLoading,
    isError: isGameCategoryError,
    isSuccess: isGameCategorySuccess,
    error: gameCategoryError,
  } = useGetGameCategoryQuery({ prefetch: true });

  const {
    data: user,
    isFetching: isUserFetching,
    isLoading: isUserLoading,
  } = useGetProfileQuery({ prefetch: true });

  const [
    getGameProvider,
    {
      data: gameProvider,
      isFetching: isGameProviderFetching,
      isLoading: isGameProviderLoading,
      isError: isGameProviderError,
      isSuccess: isGameProviderSuccess,
      error: gameProviderError,
    },
  ] = useLazyGetGameProviderGameItemQuery({ prefetch: true });

  const {
    data: casinoProvider,
    isFetching: isCasinoProviderFetching,
    isLoading: isCasinoProviderLoading,
    isError: isCasinoProviderError,
    isSuccess: isCasinoProviderSuccess,
    error: casinoProviderError,
  } = useGetGameProviderQuery({ category: "LIVE_CASINO", isHome: true }, true, {
    prefetch: true,
  });

  const {
    data: allGameProvider,
    isFetching: isAllGameProviderFetching,
    isLoading: isAllGameProviderLoading,
    isError: isAllGameProviderError,
    isSuccess: isAllGameProviderSuccess,
    error: allGameProviderError,
  } = useGetGameProviderQuery({ category: "" }, { prefetch: true });

  const [
    getLaunchGame,
    {
      data: launchGame,
      isFetching: isLaunchGameFetching,
      isLoading: isLaunchGameLoading,
      isError: isLaunchGameError,
      isSuccess: isLaunchGameSuccess,
      error: launchGameError,
    },
  ] = useLazyGetLaunchGameQuery({ prefetch: true });

  const {
    data: homePage,
    isFetching: isHomePageFetching,
    isLoading: isHomePageLoading,
    isError: isHomePagetError,
    isSuccess: isHomePageSuccess,
    error: homePageError,
  } = useGetHomePageQuery({ prefetch: true });

  const {
    data: shareLink,
    isLoading: isShareLinkLoading,
    isError: isShareLinkError,
    isSuccess: isShareLinkSuccess,
    error: shareLinkError,
  } = useGetShareLinkQuery();

  const [
    getGameItem,
    {
      data: gameItem,
      isFetching: isGameItemFetching,
      isLoading: isGameItemLoading,
      isError: isGameItemError,
      isSuccess: isGameItemSuccess,
      error: gameItemError,
    },
  ] = useLazyGetGameItemQuery({ prefetch: true });

  const appRef = useRef(null);

  const scrollToSection = (sectionRef) => {
    sectionRef.current.scrollIntoView({ behavior: 'instant' });
  };

  const handlePageChange = (e, p) => {
    setOffset(p);
    window.scroll(0, 0);
  };

  useEffect(() => {
    // Track the PageView event with Facebook Pixel
    // window.fbq("trackCustom", "PageView");
  }, []);

  useEffect(() => {
    if (isGameItemError) {
      setShowLoading(false);
      Swal.fire({
        text: gameItemError?.data?.message,
        icon: "error",
        color: "white",
        confirmButtonColor: theme.palette.primary.main,
        background: theme.palette.background.paper
      });
    }
  }, [isGameItemError]);

  useEffect(() => {
    if (isLaunchGameError) {
      setShowLoading(false);
      Swal.fire({
        text: launchGameError?.data?.message,
        icon: "error",
        color: "white",
        confirmButtonColor: theme.palette.primary.main,
        background: theme.palette.background.paper

      });
    }
  }, [isLaunchGameError]);

  useEffect(() => {
    if (!isLaunchGameLoading && !isLaunchGameFetching && isLaunchGameSuccess) {
      setShowLoading(true);

      if (launchGame?.result?.gameType === "WEB") {
        if (launchGame?.result?.iframeSupported == true) {
          setShowLoading(false);

          window.location.href = process.env.REACT_APP_GAME_URL_IFRAME + launchGame.result.gameUrl;
        }
        else {
          setShowLoading(false);

          window.open(launchGame.result.gameUrl, "_blank");
        }
      }
    }
  }, [isLaunchGameLoading, isLaunchGameFetching, isLaunchGameSuccess]);

  const add = () => setNumber((number) => number + 1);

  useEffect(() => {
    setInterval(() => {
      add();
    }, 1000);
  }, []);

  useEffect(() => {
    if (mobileView && !selectedGameCategory) {
      let hasDefaultGameCategory = false;
      additionalGameBarItems.map((item, index) => {
        if (pathname.includes(item.code.toLowerCase().replace("_", "-"))) {
          setSelectedGameCategory(item.code);
          hasDefaultGameCategory = true;
        }
      });

      if (!hasDefaultGameCategory) {
        setSelectedGameCategory("HOT_GAME");
      }
    }

  }, [mobileView]);

  useEffect(() => {
    getGameProvider().then((gameProvider) => {
      setPlatformType(gameProvider?.data?.result[0].gameType);
      setCurrentProviderId(gameProvider?.data?.result[0].id);
      setSelectedProvider(gameProvider?.data?.result[0].name);
    });

  }, [mobileView]);

  useEffect(() => {
    if (searchParams.get("refcode")) {
      localStorage.setItem("refCode", searchParams.get("refcode"));
      navigate(Constant.getPath("/register"));
    }
  }, []);

  // useEffect(() => {
  //   if (currentProviderId == null) {
  //     setCurrentProviderId(gameProvider?.result[0]?.id);
  //     }
  // });

  useEffect(() => {
    // setAppGameDisplay(false);

    getGameItem({
      category: "",
      offset: offset - 1,
      providerId: currentProviderId,
      keyword: "",
      group: currentProviderId == null ? "" : "ALL",
      hasProvider: currentProviderId != null
    });

  }, [offset, currentProviderId]);

  useEffect(() => {
    setOffset(1);
  }, [currentProviderId]);

  useEffect(() => {
    const handleDOMContentLoaded = () => {
      setDOMContentLoaded(true);
    };

    document.addEventListener('DOMContentLoaded', handleDOMContentLoaded);

    return () => {
      document.removeEventListener('DOMContentLoaded', handleDOMContentLoaded);
    };
  }, []);

  const popup = process.env.REACT_APP_POPUP;

  const closePopup = () => setPopupOpen(false);
  const openPopup = () => setPopupOpen(true);

  const closeAffiliatePopup = () => setAffiliatePopupOpen(false);
  const openAffiliatePopup = () => setAffiliatePopupOpen(true);



  if (
    isHomePageFetching ||
    isHomePageLoading ||
    isAllGameProviderFetching ||
    isAllGameProviderLoading ||
    isGameCategoryFetching ||
    isGameCategoryLoading
  ) {
    return <Backdrop />;
  }

  if (isLaunchGameFetching || isLaunchGameLoading) {
    return <Backdrop />;
  }

  const list = ["Action", "Number: 2D - 6D", "Big", "Small", "A(3D)", "ABC(3D)", "A1", "A2", "A3", "A4", "A5", "RV", "Box", "iBox"];

  const addRow = () => {
    setRows([...rows, { number2To6: '', big: '', small: '', a3d: '', abc3d: '', a1: '', a2: '', a3: '', a4: '', a5: '', rv: false, box: false, iBox: false }]);
  };

  const deleteRow = (index) => {
    setRows((prevRows) => prevRows.filter((_, i) => i !== index));
  };

  const handleChange = ((index, field, type) => {
    const updatedRows = [...rows];

    if (type === "number") {
      updatedRows[index][field.name] = field.value.replace(/[^0-9]/g, '');
      if ((field.value).length > 6) {
        updatedRows[index][field.name] = "";

        Swal.fire({
          title: "Oops",
          text: "Invalid Number, please insert 2 - 6 number!",
          icon: "error",
          color: "white",
          confirmButtonColor: theme.palette.primary.main,
          background: theme.palette.background.paper
        });
      }
    } else if (type === "bet") {

      updatedRows[index][field.name] = field.value;

      if (Number(field.value) > 200) {
        updatedRows[index][field.name] = "";

        Swal.fire({
          title: "Oops",
          text: "Invalid bet amount, bet amount should between 0 to 200",
          icon: "error",
          color: "white",
          confirmButtonColor: theme.palette.primary.main,
          background: theme.palette.background.paper
        });
      }
    }

    setRows(updatedRows);
  });

  const handleCheckboxChange = (index, field) => {
    const updatedRows = [...rows];

    updatedRows[index]["rv"] = false;
    updatedRows[index]["box"] = false;
    updatedRows[index]["iBox"] = false;

    updatedRows[index][field.name] = field.checked;

    setRows(updatedRows);
  };

  return (
    <Box pt={{ xs: 7, sm: 0, lg: 0, xl: 0 }}>
      <Modal open={showLoading}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              textAlign: "center",
              color: "#fff",
            }}
          >
            {/* current image not compatible, doesnt show correctly*/}
            {/* <img
              src="/favicon.ico"
              alt="Website Logo"
              style={{ width: "100px", marginBottom: "20px" }}
            /> */}
            <CircularProgress color="inherit" />
          </Box>
        </Box>
      </Modal>
      {/* Banner */}
      <ImageCarousel
        banners={
          mobileView
            ? homePage?.result?.mobileBanners
            : homePage?.result?.banners
        }
        navigation={false}
        spaceBetween={0}
        alt={Constant.ALT_TAG_BANNER}
      />
      {/* Marbula2 Live Streaming Video */}
      {/* <Box mt={10} display={"flex"} justifyContent={"center"}> */}
      {/* <iframe width="100%" height="250" src="https://player.twitch.tv/?channel=marbula2official&autoplay=true&muted=false&parent=localhost"
            title="Twitch video player" frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> */}

      {/* <iframe width={mobileView ? "100%" : "700"} height={mobileView ? "250" : "400"} src={`process.env.REACT_APP_HOME_VIDEO}?loop=1&autoplay=1`} title="Twitch video player" frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe> */}

      {/* <iframe width={mobileView ? "100%" : "700"} height={mobileView ? "250" : "400"} src={`https://www.youtube.com/embed/gJQUqT319X4`} title="Twitch video player" frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
      </Box> */}

      <Grid mt={2} px={{ xs: 2, xl: 20 }} spacing={1.5} sx={{ color: "white" }} container>

        {gameProvider && gameProvider?.result?.map((result) => {
          return (<Grid xs={6} sm={4} item>
            <img
              src={result?.logoUrl}
              alt="Provider"
              onClick={(() => {
                if (result?.hasGameList) {
                  setPlatformType(result?.gameType);
                  setCurrentProviderId(result?.id);
                  setAppProviderName("");
                  setSelectedProvider(result?.name);
                } else {
                  if (isLoggedIn) {
                    if (result?.gameType === "APP") {
                      setPlatformType(result?.gameType);
                      setSelectedProvider(result?.name);
                      setAppProviderName(result?.name);
                    }
                    getLaunchGame({
                      id: result?.id,
                      type: result?.gameType,
                      category: result?.category,
                      isMobile: mobileView
                    }).then((gameLaunch) => {
                      if (result?.gameType === "APP") {
                        setMobileUsername(gameLaunch?.data?.result?.mobileAppUsername);
                        setMobilePassword(gameLaunch?.data?.result?.mobileAppPassword);
                      }
                      scrollToSection(appRef);
                    });
                  }
                  else {
                    Swal.fire({
                      text: t("dialog.proceedtologin"),
                      icon: "error",
                      color: "white",
                      confirmButtonColor: theme.palette.primary.main,
                      background: theme.palette.background.paper
                    });
                  }
                }
              })}
              style={{
                msUserSelect: 'none',
                WebkitUserSelect: 'none',
                userSelect: 'none',
                width: '100%',
                height: !mobileView ? '120px' : '75px',
                borderRadius: '20px',
                border: selectedProvider === result.name ? `3px solid #05d300` : `2px dotted #05d300`,
                cursor: 'pointer'
              }}
            />
          </Grid>)
        })}


        {/* <Grid xs={6} sm={3} item>
          <img
            src="/assets/img/Website11811-2.png"
            alt="App"
            style={{
              width: '100%', height: !mobileView ? '120px' : "80px", borderRadius: "20px", border: "1px dotted orange", cursor: "pointer"
            }} />
        </Grid>

        <Grid xs={6} sm={3} item>
          <img
            src="/assets/img/Website11811-3.png"
            alt="App"
            style={{
              width: '100%', height: !mobileView ? '120px' : "80px", borderRadius: "20px", border: "1px dotted orange", cursor: "pointer"
            }} />
        </Grid>

        <Grid xs={6} sm={3} item>
          <img
            src="/assets/img/Website11811-4.png"
            alt="App"
            style={{
              width: '100%', height: !mobileView ? '120px' : "80px", borderRadius: "20px", border: "1px dotted orange",
              cursor: "pointer"
            }} />
        </Grid> */}

        {/* {gameProvider?.result?.map((provider, index) => (
            <Grid key={index} xs={6} sm={3} item>
              <Box onClick={() => { setCurrentProviderId(provider.id); setPlatformType("WEB"); }} py={1.5} sx={{
                cursor: "pointer",
                userSelect: 'none',
                width: "100%",
                textAlign: "center",
                borderRadius: 1,
                border: "1px dotted orange",
                background: `url(${provider.homeGameImgUrl})`
              }}>{provider.name}</Box>
            </Grid>
          ))} */}
      </Grid>

      {/* {mobileView && platformType === "WEB" && (
        <div style={{ display: 'flex', marginTop: 20 }}>
          <div style={{
            padding: "0 25px",
            flex: '70%', background: 'black', display: 'flex', flexDirection: 'column', height: '540px', overflowY: 'auto',
            scrollbarWidth: 'thin', // For Firefox
            scrollbarColor: 'transparent transparent', // For Firefox
            '&::-webkit-scrollbar': {
              width: '0.4em',
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: 'transparent',
            },
          }}>
            <Box p={0} mt={0} style={{ flex: '80%', overflowY: 'auto' }}>
              {selectedGameCategory == 'HOT_GAME' && !isHomePageFetching && !isHomePageLoading && isHomePageSuccess && (
                <>
                  <Grid container>
                    {homePage?.result?.recommendGame?.map((game, idx) => (
                      <Grid
                        key={idx}
                        item
                        xs={4}
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        <Box
                          onClick={() => {
                            //TODO cater game provider in Hot Game section
                            let hasGameList = false;
                            if (hasGameList) {
                              navigate(
                                Constant.getPath(`/game/${selectedGameCategory?.toLowerCase()}`),
                                {
                                  state: {
                                    providerId: game.providerId,
                                  },
                                }
                              );
                            } else {
                              if (!isLoggedIn) {
                                // dispatch(
                                //     openModal({
                                //       title: t("dialog.proceedtologin"),
                                //       button: [
                                //         {
                                //           label: t("dialog.login"),
                                //           onSubmit: () => {
                                //             dispatch(closeModal());
                                navigate(Constant.getPath("/login"));
                                //       },
                                //     },
                                //   ],
                                // })
                                // );
                              } else {
                                getLaunchGame({
                                  id: game?.id,
                                  type: game?.gameType,
                                  category: game.categoryCode,
                                  isMobile: mobileView
                                });
                              }
                            }
                          }}
                          sx={{
                            margin: '3px', // Adjust the value to set the desired spacing
                          }}
                        >
                          <Box display="flex" flexDirection="column" position="relative">
                            <Image src={game.homeThumbnailUrl} alt={Constant.ALT_TAG_GENERAL_PROVIDER + game.name} sx={{ borderRadius: "5px" }} />
                            
                            <Typography
                              color="white"
                              fontSize={9}
                              textAlign="left"
                              fontWeight={400}
                              sx={{
                                marginTop: "5px",
                              }}
                            >
                              {game.name}
                            </Typography>
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </>
              )}
              {selectedGameCategory != 'HOT_GAME' && !isGameProviderFetching && !isGameProviderLoading && isGameProviderSuccess && (
                <>
                  <Grid container>
                    {gameProvider?.result?.map((provider, idx) => (
                      <Grid
                        key={idx}
                        item
                        xs={selectedGameCategory === 'SLOT' || selectedGameCategory === 'FISH_HUNTER' ? 6 : 12}
                        sx={{
                          textAlign: 'center',
                        }}
                      >
                        <Box
                          onClick={() => {
                            let hasGameList = gameCategory?.result?.find(
                              (category) =>
                                category.code === selectedGameCategory
                            )?.hasGameList;
                            if (hasGameList) {
                              navigate(
                                Constant.getPath(`/game/${selectedGameCategory?.toLowerCase()}`),
                                {
                                  state: {
                                    providerId: provider.id,
                                  },
                                }
                              );
                            } else {
                              if (!isLoggedIn) {
                                // dispatch(
                                //     openModal({
                                //       title: t("dialog.proceedtologin"),
                                //       button: [
                                //         {
                                //           label: t("dialog.login"),
                                //           onSubmit: () => {
                                //             dispatch(closeModal());
                                navigate(Constant.getPath("/login"));
                                //       },
                                //     },
                                //   ],
                                // })
                                // );
                              } else {
                                getLaunchGame({
                                  id: provider?.id,
                                  type: provider?.gameType,
                                  category: selectedGameCategory,
                                  isMobile: mobileView
                                });
                              }
                            }
                          }}
                          sx={{
                            margin: '3px', // Adjust the value to set the desired spacing
                          }}
                        >
                          <Box display="flex" flexDirection="column">
                            <Image src={provider.homeThumbnailUrl} alt={Constant.ALT_TAG_GENERAL_PROVIDER + provider.name} />
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </>
              )}
            </Box>
          </div>
        </div>
      )} */}

      {/* {platformType === "LOTTERY" && (
        mobileView && (
          <Box px={1.5}>
            <Box color={"white"} mt={3} >
              <Typography fontSize={12}>Choose Date: </Typography>
              <Grid spacing={1} container>
                {Array.from({ length: 4 }).map((_, index) => {
                  const date = moment().add(index, 'days').format('YYYY-MM-DD');
                  return (
                    <Grid xs={6} item>
                      <Box onClick={() => { setSelectedDate(date) }} py={1.5} sx={{
                        backgroundColor: selectedDate === date ? "red" : undefined, userSelect: 'none', cursor: "pointer", width: "100%", textAlign: "center", borderRadius: 1, border: "1px dotted orange", fontSize: 12,
                        fontWeight: "bold",
                      }}>{date}</Box>
                    </Grid>
                  )
                })}
              </Grid>
              <Typography mt={0.5} fontSize={12}>Choose Pools: </Typography>
              <Typography fontSize={12}>* Press pool image to select </Typography>
              <Typography fontSize={12}>* More than one pool (s) can be selected </Typography>
            </Box>

            <Grid mt={3} px={3} spacing={1} container>
              <Grid xs={4} sm={1} item>
                <Button py={1.5} sx={{ fontWeight: "bold", fontSize: 12, width: "100%", textAlign: "center", backgroundColor: "red", borderRadius: 1, border: "1px dotted orange" }}>Magnum</Button>
              </Grid>
              <Grid xs={4} sm={1} item>
                <Button py={1.5} sx={{ fontWeight: "bold", fontSize: 12, width: "100%", textAlign: "center", backgroundColor: "red", borderRadius: 1, border: "1px dotted orange" }}>Damacai</Button>
              </Grid>
              <Grid xs={4} sm={1} item>
                <Button py={1.5} sx={{ fontWeight: "bold", fontSize: 12, width: "100%", textAlign: "center", backgroundColor: "red", borderRadius: 1, border: "1px dotted orange" }}>Toto</Button>
              </Grid>
              <Grid xs={4} sm={1} item>
                <Button py={1.5} sx={{ fontWeight: "bold", fontSize: 12, width: "100%", textAlign: "center", backgroundColor: "red", borderRadius: 1, border: "1px dotted orange" }}>Sabah</Button>
              </Grid>
            </Grid>

            <Box mt={2} sx={{ borderTop: "1px solid white" }}>
              {
                rows.map((row, index) => {
                  return (
                    <Box py={1.5} sx={{ borderBottom: "1px solid", borderColor: "white" }}>
                      <Delete onClick={() => deleteRow(index)} color="primary" sx={{ cursor: "pointer", height: "25px", width: "25px" }} />

                      <Grid container>
                        <Grid item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"Number: 2D - 6D"}</Typography>

                          <TextField
                            value={row.number2To6}
                            name="number2To6"
                            onChange={(e) => handleChange(index, e.target, "number")}
                            InputProps={{
                              sx: { height: 30, fontSize: 14 }
                            }} />
                        </Grid>

                        {['rv', 'box', 'iBox'].map(field => (
                          <Grid item>
                            <Typography textAlign={"center"} color={"white"} fontSize={11}>{field}</Typography>
                            <Checkbox name={field} checked={row[field]} onChange={(e) => handleCheckboxChange(index, e.target)}
                              sx={{ marginTop: 0 }} />
                          </Grid>
                        ))}
                      </Grid>

                      <Grid spacing={1} container>
                        <Grid xs={3} item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"Big"}</Typography>

                          <TextField
                            value={row.big}
                            name="big"
                            onChange={(e) => handleChange(index, e.target, "bet")}
                            type="number"
                            InputProps={{
                              sx: { height: 30, fontSize: 14 },
                              inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                              style: {
                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                  display: 'none',
                                },
                                '&[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }} />
                        </Grid>
                        <Grid xs={3} item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"Small"}</Typography>

                          <TextField
                            value={row.small}
                            name="small"
                            onChange={(e) => handleChange(index, e.target, "bet")}
                            type="number"
                            InputProps={{
                              sx: { height: 30, fontSize: 14 },
                              inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                              style: {
                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                  display: 'none',
                                },
                                '&[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }} />
                        </Grid>

                        <Grid xs={3} item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"A(3D)"}</Typography>

                          <TextField
                            value={row.a3d}
                            name="a3d"
                            onChange={(e) => handleChange(index, e.target, "bet")}
                            type="number"
                            InputProps={{
                              sx: { height: 30, fontSize: 14 },
                              inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                              style: {
                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                  display: 'none',
                                },
                                '&[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }} />
                        </Grid>

                        <Grid xs={3} item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"ABC(3D)"}</Typography>

                          <TextField
                            value={row.abc3d}
                            name="abc3d"
                            type="number"
                            InputProps={{
                              sx: { height: 30, fontSize: 14 },
                              inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                              style: {
                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                  display: 'none',
                                },
                                '&[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }} />
                        </Grid>

                        <Grid xs={2.4} item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"A1"}</Typography>

                          <TextField
                            value={row.a1}
                            name="a1"
                            onChange={(e) => handleChange(index, e.target, "bet")}
                            type="number"
                            InputProps={{
                              sx: { height: 30, fontSize: 14 },
                              inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                              style: {
                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                  display: 'none',
                                },
                                '&[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }} />
                        </Grid>

                        <Grid xs={2.4} item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"A2"}</Typography>

                          <TextField
                            value={row.a2}
                            name="a2"
                            onChange={(e) => handleChange(index, e.target, "bet")}
                            type="number"
                            InputProps={{
                              sx: { height: 30, fontSize: 14 },
                              inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                              style: {
                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                  display: 'none',
                                },
                                '&[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }} />
                        </Grid>

                        <Grid xs={2.4} item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"A3"}</Typography>

                          <TextField
                            value={row.a3}
                            name="a3"
                            onChange={(e) => handleChange(index, e.target, "bet")}
                            type="number"
                            InputProps={{
                              sx: { height: 30, fontSize: 14 },
                              inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                              style: {
                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                  display: 'none',
                                },
                                '&[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }} />
                        </Grid>

                        <Grid xs={2.4} item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"A4"}</Typography>

                          <TextField
                            value={row.a4}
                            name="a4"
                            onChange={(e) => handleChange(index, e.target, "bet")}
                            type="number"
                            InputProps={{
                              sx: { height: 30, fontSize: 14 },
                              inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                              style: {
                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                  display: 'none',
                                },
                                '&[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }} />
                        </Grid>

                        <Grid xs={2.4} item>
                          <Typography textAlign={"center"} color={"white"} fontSize={11}>{"A5"}</Typography>

                          <TextField
                            value={row.a5}
                            name="a5"
                            onChange={(e) => handleChange(index, e.target, "bet")}
                            type="number"
                            InputProps={{
                              sx: { height: 30, fontSize: 14 },
                              inputProps: { min: 0, style: { MozAppearance: 'textfield' } },
                              style: {
                                '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
                                  display: 'none',
                                },
                                '&[type=number]': {
                                  MozAppearance: 'textfield',
                                },
                              },
                            }} />
                        </Grid>
                      </Grid>
                    </Box>
                  )
                })
              }
            </Box>

            <Box display="flex"
              justifyContent="flex-end"
              alignItems={"flex-end"}
              flexDirection={"column"}
              mt={4} mr={2}>
              <Button onClick={() => addRow()} sx={{
                backgroundColor: "red",
                borderRadius: 1,
                fontSize: 12,
                fontWeight: "bold",
                padding: "6px 20px",
              }}>Add Number +</Button>
              <Typography fontSize={12} mt={3} color={"white"}>
                Total : 0.00
              </Typography>
              <Typography fontSize={12} color={"white"}>
                Wallet : {user?.result?.currentCredit || "0.00"}
              </Typography>
              <Typography fontSize={12} color={"white"}>
                Wallet Remaining : 0.00
              </Typography>

              <Button
                onClick={() => {
                  if (isLoggedIn) {

                  } else {
                    navigate(Constant.getPath("/login"));
                  }
                }}
                sx={{
                  marginTop: 2, backgroundColor: "red", borderRadius: 1, fontSize: 12,
                  fontWeight: "bold",
                }}>Order</Button>
              <Button sx={{
                padding: "15px 40px", marginTop: 1.5, backgroundColor: "red", borderRadius: 1, fontSize: 12,
                fontWeight: "bold",
              }}>More Betting</Button>
            </Box>
          </Box>))} */}

      {/* {platformType === "LOTTERY" && (
        !mobileView && (
          <Box px={10}>
            <Box color={"white"} mt={3} >
              <Typography>Choose Date: </Typography>
              <Grid spacing={1} container>
                {Array.from({ length: 4 }).map((_, index) => {
                  const date = moment().add(index, 'days').format('YYYY-MM-DD');
                  return (
                    <Grid xs={6} sm={3} item>
                      <Box onClick={() => { setSelectedDate(date) }} py={1.5} sx={{ backgroundColor: selectedDate === date ? "red" : undefined, userSelect: 'none', cursor: "pointer", width: "100%", textAlign: "center", borderRadius: 1, border: "1px dotted orange" }}>{date}</Box>
                    </Grid>
                  )
                })}
              </Grid>
              <Typography>Choose Pools: </Typography>
              <Typography>* Press pool image to select </Typography>
              <Typography>* More than one pool (s) can be selected </Typography>
            </Box>

            <Grid mt={6} spacing={1} container>
              <Grid xs={4} sm={1} item>
                <Button py={1.5} sx={{ width: "100%", textAlign: "center", backgroundColor: "red", borderRadius: 1, border: "1px dotted orange" }}>Magnum</Button>
              </Grid>
              <Grid xs={4} sm={1} item>
                <Button py={1.5} sx={{ width: "100%", textAlign: "center", backgroundColor: "red", borderRadius: 1, border: "1px dotted orange" }}>Damacai</Button>
              </Grid>
              <Grid xs={4} sm={1} item>
                <Button py={1.5} sx={{ width: "100%", textAlign: "center", backgroundColor: "red", borderRadius: 1, border: "1px dotted orange" }}>Toto</Button>
              </Grid>
              <Grid xs={4} sm={1} item>
                <Button py={1.5} sx={{ width: "100%", textAlign: "center", backgroundColor: "red", borderRadius: 1, border: "1px dotted orange" }}>Sabah</Button>
              </Grid>
            </Grid>

            <TableContainer sx={{ marginTop: 2, color: "white" }}>
              <Table sx={{ color: "white" }}>
                <TableHead>
                  <TableRow>
                    {list.map((item) => {
                      return (
                        <TableCell sx={{ color: "white", textAlign: "center" }}>
                          {item}
                        </TableCell>
                      )
                    })}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {
                    rows.map((row, index) => {
                      return (
                        <TableRow key={index} >
                          <TableCell>
                            <Delete onClick={() => deleteRow(index)} color="primary" sx={{ cursor: "pointer", height: "25px", width: "25px" }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.number2To6}
                              name="number2To6"
                              onChange={(e) => handleChange(index, e.target, "number")}

                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                },
                              }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.big}
                              name="big"
                              onChange={(e) => handleChange(index, e.target, "bet")}
                              type="number"
                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                    '&::-webkit-outer-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                    '&::-webkit-inner-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                  },
                                },
                              }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.small}
                              name="small"
                              onChange={(e) => handleChange(index, e.target, "bet")}
                              type="number"
                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                    '&::-webkit-outer-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                    '&::-webkit-inner-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                  },
                                },
                              }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.a3d}
                              name="a3d"
                              onChange={(e) => handleChange(index, e.target, "bet")}
                              type="number"
                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                    '&::-webkit-outer-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                    '&::-webkit-inner-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                  },
                                },
                              }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.abc3d}
                              name="abc3d"
                              onChange={(e) => handleChange(index, e.target, "bet")}
                              type="number"
                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                    '&::-webkit-outer-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                    '&::-webkit-inner-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                  },
                                },
                              }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.a1}
                              name="a1"
                              onChange={(e) => handleChange(index, e.target, "bet")}
                              type="number"
                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                    '&::-webkit-outer-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                    '&::-webkit-inner-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                  },
                                },
                              }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.a2}
                              name="a2"
                              onChange={(e) => handleChange(index, e.target, "bet")}
                              type="number"
                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                    '&::-webkit-outer-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                    '&::-webkit-inner-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                  },
                                },
                              }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.a3}
                              name="a3"
                              onChange={(e) => handleChange(index, e.target, "bet")}
                              type="number"
                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                    '&::-webkit-outer-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                    '&::-webkit-inner-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                  },
                                },
                              }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.a4}
                              name="a4"
                              onChange={(e) => handleChange(index, e.target, "bet")}
                              type="number"
                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                    '&::-webkit-outer-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                    '&::-webkit-inner-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                  },
                                },
                              }} />
                          </TableCell>
                          <TableCell>
                            <TextField
                              value={row.a5}
                              name="a5"
                              onChange={(e) => handleChange(index, e.target, "bet")}
                              type="number"
                              InputProps={{
                                sx: {
                                  height: 40,
                                  fontSize: 14,
                                  '& input[type=number]': {
                                    MozAppearance: 'textfield',
                                    '&::-webkit-outer-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                    '&::-webkit-inner-spin-button': {
                                      WebkitAppearance: 'none',
                                      margin: 0,
                                    },
                                  },
                                },
                              }} />
                          </TableCell>

                          {['rv', 'box', 'iBox'].map(field => (
                            <TableCell key={field}>
                              <Checkbox name={field} checked={row[field]} onChange={(e) => handleCheckboxChange(index, e.target)} />
                            </TableCell>
                          ))}
                        </TableRow>
                      )
                    })
                  }
                </TableBody>
              </Table>
            </TableContainer>

            <Box display="flex"
              justifyContent="flex-end"
              alignItems={"flex-end"}
              flexDirection={"column"}
              mt={4} mr={2}>
              <Button onClick={() => addRow()} sx={{ backgroundColor: "red", borderRadius: 1 }}>Add Number +</Button>
              <Typography mt={3} color={"white"}>
                Total : 0.00
              </Typography>
              <Typography color={"white"}>
                Wallet : {user?.result?.currentCredit || "0.00"}
              </Typography>
              <Typography color={"white"}>
                Wallet Remaining : 0.00
              </Typography>

              <Button onClick={() => {
                if (isLoggedIn) {

                } else {
                  Swal.fire({
                    title: "Oops",
                    text: "Please login to continue.",
                    icon: "info",
                    color: "white",
                    confirmButtonColor: theme.palette.primary.main,
                    background: theme.palette.background.paper
                  });
                }
              }} sx={{ marginTop: 2, backgroundColor: "red", borderRadius: 1 }}>Order</Button>
              <Button sx={{ padding: "5px 40px", marginTop: 3, backgroundColor: "red", borderRadius: 1 }}>More Betting</Button>
            </Box>
          </Box>))} */}

      {
        platformType === "APP" && (
          <Box ref={appRef} display="flex" flexDirection="column" pt={2} pb={3.5}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              alignSelf="center"
              pt={2}
              pb={3}
              px={{ xs: 3 }}
            >
              <Image src={launchGame?.result?.bannerUrl} />
              <Typography color={theme.palette.primary.main} pt={2}>
                {`EASY STEP BY STEP TO PLAY ${appProviderName} ON YOUR MOBILE`}
              </Typography>
              <Typography color={theme.palette.primary.main} pt={2}>
                Step 1
              </Typography>
              <Typography color={"white"}>
                {`Transfer fund into ${appProviderName} wallet to get your login ID and password on the below section of this page.`}
              </Typography>
              <Typography color={theme.palette.primary.main} pt={2}>
                Step 2
              </Typography>
              <Typography color={"white"}>
                {`Download ${appProviderName} from the download link below.`}
              </Typography>
              <Typography color={theme.palette.primary.main} pt={2}>
                Step 3
              </Typography>
              <Typography color={"white"} pb={3}>
                {`Launch the apps in your mobile and login with the ID and password from below.`}
              </Typography>
              <Divider />
              <FormControl
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  pt: 4,
                  "& .MuiTextField-root": {
                    pb: 3,
                  },
                }}
              >
                <TextField
                  label="Username"
                  // value={launchGame?.result?.mobileAppUsername}
                  value={mobileUsername}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  type="text"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          disableRipple
                          sx={{
                            "&.MuiButtonBase-root:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                        >
                          <CopiedTooltip
                            text={launchGame?.result?.mobileAppUsername}
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <TextField
                  label="Password"
                  // value={launchGame?.result?.mobileAppPassword}
                  value={mobilePassword}
                  InputLabelProps={{ shrink: true }}
                  disabled
                  type="text"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          disableRipple
                          sx={{
                            "&.MuiButtonBase-root:hover": {
                              backgroundColor: "transparent",
                            },
                          }}
                        >
                          <CopiedTooltip
                            text={launchGame?.result?.mobileAppPassword}
                          />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </Box>
            <Box display="flex" alignSelf="center">
              <Button
                variant="contained"
                sx={{
                  backgroundColor: theme.palette.button.primary.main,
                }}
                onClick={() => {
                  let url = launchGame.result.mobileAppUrlIos[0];
                  // if (
                  //     !pattern.test(launchGame.result.mobileAppUrlIos[0])
                  // ) {
                  //     url = "https://" + url;
                  // }
                  window.open("https://" + url, "_blank");
                }}
              >
                IOS
              </Button>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: theme.palette.button.primary.main,
                  ml: 2,
                }}
                onClick={() => {
                  let url = launchGame.result.mobileAppUrlAndroid[0];
                  // if (
                  //     !pattern.test(
                  //         launchGame.result.mobileAppUrlAndroid[0]
                  //     )
                  // ) {
                  //     url = "https://" + url;
                  // }
                  window.open("https://" + url, "_blank");
                }}
              >
                ANDROID
              </Button>
            </Box>
          </Box>
        )
      }

      {/* { Game Item List } */}
      {
        platformType === "WEB" && (
          <Box mt={2} pb={5}>
            {!isGameItemLoading &&
              isGameItemSuccess && (
                <>
                  <Grid
                    container
                    spacing={{ xs: 1.6, sm: 1, md: 1.5, lg: 3.5 }}
                    alignItems={"center"}
                    justifyContent="center"
                    mt={mobileView ? 0 : 1}
                    px={{ xs: 3.5, sm: 5, md: 8, lg: 21 }}
                  >
                    {gameItem?.result?.data?.map((game, index) => (
                      <>
                        {(
                          <Grid
                            item
                            xs={mobileView ? 3 : 0}
                            key={index}
                            display="flex"
                            justifyContent="center"
                          >
                            <GameCard
                              imageUrl={game?.thumbnailUrl}
                              imageWidth={
                                mobileView
                                  ? "75px"
                                  : tabletView
                                    ? "120px"
                                    : "140px"
                              }
                              imageHeight={
                                mobileView
                                  ? "75px"
                                  : tabletView
                                    ? "120px"
                                    : "140px"
                              }
                              height="150px"
                              alt={Constant.ALT_TAG_GENERAL_GAME + game.name}
                              onClick={() => {
                                if (!isLoggedIn) {
                                  dispatch(
                                    openModal({
                                      title: t("dialog.proceedtologin"),
                                      button: [
                                        {
                                          label: t("dialog.login"),
                                          onSubmit: () => {
                                            dispatch(closeModal());
                                            if (mobileView) {
                                              navigate(Constant.getPath("/login"));
                                            }
                                          },
                                        },
                                      ],
                                    })
                                  );
                                } else {
                                  getLaunchGame({
                                    id: game?.id,
                                    type: game?.gameType,
                                    category: game?.categoryCode,
                                    isMobile: mobileView
                                  });
                                }
                              }}
                              title={game?.name}
                              subtitle={
                                gameProvider?.result?.find(
                                  (provider) => provider?.id === game?.providerId
                                )?.name
                              }
                              description={{}}
                            />
                          </Grid>
                        )}
                      </>
                    ))}
                  </Grid>
                  {gameItem?.result?.totalPage !== 0 && (
                    <Stack
                      mt={tabletView ? 0 : 2}
                      spacing={2}
                      size="small"
                      alignItems="center"
                    >
                      <Pagination
                        onChange={handlePageChange}
                        count={gameItem?.result?.totalPage}
                        shape="rounded"
                        page={offset}
                        sx={{
                          "& .MuiPaginationItem-root": {
                            color: "white",
                            "&.Mui-selected": {
                              background: lighten(
                                theme.palette.background.paper,
                                0.02
                              ),
                              color: "white",
                            },
                          },
                        }}
                      />
                    </Stack>
                  )}
                </>
              )}
          </Box>
        )
      }

      {
        mobileView && (
          <Box mt={3}
            sx={{
              background: `url('${homePage?.mobileBackground[2]?.thumbnailUrl}')`,
            }}
          >
            <Container maxWidth={false} disableGutters>
              <Box pb={11}>
                <Image
                  src={homePage?.result?.walletSteps}
                  alt={Constant.ALT_TAG_STEPS}
                  width="100%"
                  height="auto"
                  maxWidth="100%"
                  objectFit="cover"
                  display="block"
                />
              </Box>
            </Container>
          </Box>
        )
      }
    </Box >
  );
};

export default Home;
